import {
  DEFAULT_ANCHOR_BY_TYPE,
  DEFAULT_THICKNESS,
  ElementState,
  ElementType,
  Text,
} from '@ritabygglov/core';

export const createText = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string,
  options: Partial<Text> = {}
): Text => {
  return {
    type: ElementType.Text,
    width: 200,
    height: 32,
    text: 'Text',
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    style: {
      fill: 'transparent',
      fontSize: '14px',
    },
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    thickness: DEFAULT_THICKNESS,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Text],
    diagonalHatch: false,
    ...options,
    id,
    x: initialX,
    y: initialY,
  };
};
